module.exports = __webpack_public_path__ + "media/country_flags/de-cf7b17a9.png";